// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4fb29a61","787":"cb22802c","938":"c043ef97"}[chunkId] + ".chunk.js";
};